<template>
  <nav class="country-language-selector">
    <template v-for="country in resolvedCountries">
      <template v-if="country.children.length > 1">
        <div :key="country.id">
          <strong class="country-language-selector__title">
            {{ country.columns.title[currentLanguage] }}
            <FlagIcon
              :lang="country.columns.country"
              class="country-language-selector__flag"
            />
          </strong>
          <ul class="country-language-selector__languages">
            <li
              v-for="language in country.children"
              :key="language.id"
              class="country-language-selector__language"
              @click="$emit('select')"
            >
              <a
                :href="`/${language.columns.country}/${language.columns.language}`"
                :data-test-id="`switch-to-${language.columns.country}-${language.columns.language}`"
                class="country-language-selector__link"
                @click="handleClick"
              >
                {{ language.columns.title[currentLanguage] }}
              </a>
            </li>
          </ul>
        </div>
      </template>
      <template v-else>
        <div :key="country.id">
          <a
            :href="`/${country.columns.country}/${currentLanguage}`"
            class="country-language-selector__standalone-title"
            :data-test-id="`switch-to-${country.columns.country}-${currentLanguage}`"
            @click="handleClick"
          >
            {{ country.columns.title[currentLanguage] }}
            <FlagIcon
              :lang="country.columns.country"
              class="country-language-selector__flag"
            />
          </a>
        </div>
      </template>
    </template>
  </nav>
</template>

<script>
import { CountryFolder } from 'beisheim/models'
import FlagIcon from 'beisheim/components/elements/flag-icon'
import withMessages from '@i22/frontend-cms-utils/mixins/with-messages'

export default {
  components: {
    FlagIcon
  },
  mixins: [ withMessages ],
  props: {
    countries: {
      type: Array,
      default: null
    }
  },
  computed: {
    currentLanguage () {
      return this.$route.params.language || 'de'
    },
    resolvedCountries () {
      return this.countries.map(c => CountryFolder.query().where(r => r.columns.country === c.columns.country).first())
    }
  },
  methods: {
    handleClick (e) {
      // If CMS is Active
      if (this.$cms) {
        // Prevent default behavior
        e.preventDefault()
        // Send message to CMS to change route
        this.routeChangedMessage({
          to: e.target.getAttribute('href'),
          from: window.location.pathname
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';

  .country-language-selector {
    &:first-child {
      margin-bottom: scale(6);
    }
  }

  .country-language-selector__flag {
    width: 16px;
    position:absolute;
    right: scale(6);
    top: calc(50% - 6px);
  }

  .country-language-selector__title {
    @include font(-1);
    display: block;
    position: relative;
    font-size: font-size(-1);
    white-space: nowrap;
    padding: scale(3) scale(6);
    border-bottom: 1px solid gray(3);
  }

  .country-language-selector__standalone-title {
    display: block;
    position: relative;
    white-space: nowrap;
    padding: scale(3);

    &.router-link-active {
      cursor: default;
      color: #999999;
    }

    &:not(.router-link-active) {
      cursor: pointer;
      transition: background-color 0.2s ease-in-out;

      &:hover, &:focus {
        background-color: gray(3);
      }
    }
  }

  .country-language-selector__language {
    &:not(:last-child) {
      border-bottom: 1px solid gray(3);
    }
  }
  .country-language-selector__link {
    display: block;
    padding: scale(4) scale(6) scale(3) scale(6);

    &:not(.router-link-active) {
      transition: background-color 0.2s ease-in-out;

      &:hover, &:focus {
        background-color: gray(3);
      }
    }

    &.router-link-active {
      color: #999999;
      display: flex;
      justify-content: space-between;
      cursor: default;

      &:after {
        content:url('~beisheim/assets/images/icons/icon-check.svg');
      }
    }
  }
</style>
